// src/router/depots.js

const depotsBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Depots',
        to: 'Depots'
    }
]

export default [
    {
        path: '/depots',
        name: 'Depots',
        component: () => import('@/views/Depots/DepotListPage.vue'),
        meta: {
            title: 'Depots',
            breadcrumb: depotsBreadCrumb
        },
    },
    {
        path: '/depots/novo',
        name: 'DepotNovo',
        component: () => import('@/views/Depots/NovoDepotPage.vue'),
        meta: {
            title: 'Novo Depot',
            breadcrumb: [
                ...depotsBreadCrumb,
                {
                    label: 'Novo Cliente',
                    to: 'ClienteNovo'
                }
            ]
        }
    },
    {
        path: '/depots/:id/edit',
        name: 'DepotEdit',
        component: () => import('@/views/Depots/NovoDepotPage.vue'),
        meta: {
            title: 'Detalhes do Cliente',
            breadcrumb: [
                ...depotsBreadCrumb,
                {
                    label: 'Novo Depot',
                    to: 'DepotNovo'
                }
            ]
        }
    }

];
